import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiClientService {
    constructor(private http: HttpClient) {}

    private apiUrl = environment.apiUrl;

    get<T>(url: string, params?: any): Observable<T> {
        return this.http
            .get<T>(`${this.apiUrl}` + apiUrl(url), { params })
            .pipe(
                catchError((err) => {
                    throw err;
                })
            );
    }

    post<T>(
        url: string,
        body: any,
        options?: {
            headers?: HttpHeaders | { [header: string]: string | string[] };
            observe?: 'body';
            params?: { [param: string]: string | string[] };
            reportProgress?: boolean;
            responseType?: 'json';
            withCredentials?: boolean;
        }
    ): Observable<T> {
        return this.http
            .post<T>(`${this.apiUrl}` + apiUrl(url), body, options)
            .pipe(
                catchError((err) => {
                    throw err;
                })
            );
    }
}

export function apiUrl(urlSufix: string) {
    return `/api/${urlSufix}`;
}
